import { render, staticRenderFns } from "./FormResource.vue?vue&type=template&id=046b25e8&scoped=true&"
import script from "./FormResource.vue?vue&type=script&lang=js&"
export * from "./FormResource.vue?vue&type=script&lang=js&"
import style0 from "./FormResource.vue?vue&type=style&index=0&id=046b25e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046b25e8",
  null
  
)

export default component.exports